import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  mmbRollOutMarketList: {},
  isLoading: false,
  error: "",
  hasData: false,
  mmbRollOutMarketStatus: {
    status: false,
    message: ""
  }
};
const mmbRollOutMarketListSlice = createSlice({
  name: "mmbMarketRollout",
  initialState,
  reducers: {
    mmbRollOutListRequest: state => {
      state.isLoading = true;
    },
    mmbRollOutListSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.mmbRollOutMarketList = action.payload;
      state.mmbRollOutMarketStatus = true;
    },
    mmbRollOutListFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.mmbRollOutMarketStatus = false;
    }
  }
});
export const {
  mmbRollOutListRequest,
  mmbRollOutListSuccess,
  mmbRollOutListFailure
} = mmbRollOutMarketListSlice.actions;
export default mmbRollOutMarketListSlice.reducer;